module.exports = __webpack_public_path__ + "main/images/shared/google-color-logo.fed1e730c922a21a5fad47fd142a9d5a.svg";